import { Box, CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { useMemo, useState } from "react";
import useStyles from "./styles";
import theme from "./theme";

import {
	createBrowserRouter,
	createRoutesFromElements,
	Navigate,
	Route,
	RouterProvider,
	Routes,
} from "react-router-dom";
import { RangeProvider } from "./pages/range";
import Cadastro from "./pages/cadastro";
import Layout from "./pages/layout";
import { default as LayoutCadastro } from "./pages/layoutCadastro";
import Login from "./pages/login";
import Perfil from "./pages/perfil";
import InternoPerfilCliente from "./pages/perfil/cadastro";
import HostsConfig from "./pages/perfil/hostsConfig";
import Acessos from "./pages/perfil/acessos";
import GrupoEconomicoPerfil from "./pages/perfil/grupoEconomico";
import RedefinirSenha from "./pages/redefinirSenha";
import SolicitarRedefinirSenha from "./pages/solicitarRedefinirSenha";

//import Auditoria from "./pages/administracao/auditoria";
//import RegistroLogin from "./pages/administracao/registroLogin";

import PainelDeLogs from "./pages/administracao/auditoria";
import ClientRoute from "./routes/clientes";
/* import Contratos from "./pages/administracao/contratos"; */
import ProtectedRoute from "./pages/protectedInternoAdmRoute";

import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./components/artsPersonComponent/errorPage";
import ErrorPageConnection from "./components/artsPersonComponent/errorPageConnection";

import Usuarios from "./pages/usuarios";
import Templates from "./pages/templates";
import IntegracaoErp from "./pages/integracaoErp";
import Versionamento from "./pages/versionamento";
import Licencas from "./pages/administracao/licencas";

function App() {
	//Modo dark setado no localStorage
	const themeLocalSotarege = localStorage.getItem("darkMode");
	const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
	//Conversao para boolean
	const boleandThemeLocalStorage =
		themeLocalSotarege !== null && themeLocalSotarege !== undefined
			? JSON.parse(themeLocalSotarege)
			: null;

	//Preferencia caso nao tenha no localStorage
	const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

	const [colorMode, setColorMode] = useState(
		boleandThemeLocalStorage !== null
			? boleandThemeLocalStorage
			: prefersDarkMode,
	);
	const [contratoVencimento, setContratoVencimento] = useState(false);
	const styles = useStyles(colorMode);
	const myTheme = useMemo(() => theme(colorMode), [colorMode]);

	const router = createBrowserRouter(
		createRoutesFromElements(
			<Route
				path="*"
				element={
					<ThemeProvider theme={myTheme}>
						<CssBaseline />
						<Box
							className="App"
							sx={{
								backgroundColor: "background.wallpaper",
								minHeight: "100vh",
							}}
						>
							<RangeProvider>
								<ErrorBoundary
									FallbackComponent={({ error, resetErrorBoundary }) => (
										<ErrorPage
											error={error}
											resetErrorBoundary={resetErrorBoundary}
											gradientDark={myTheme.palette.buttonHoverGradient.dark}
											gradientLight={myTheme.palette.buttonHoverGradient.light}
											backgroundColor={myTheme.palette.background.wallpaper}
											paperErrorPage={myTheme.palette.paperErrorPage.main}
										/>
									)}
								>
									<Routes>
										<Route
											path="*"
											element={<Navigate replace to="/login" />}
										/>

										<Route exact path="/login" element={<Login />} />

										<Route
											element={
												<LayoutCadastro
													colorMode={colorMode}
													setColorMode={setColorMode}
												/>
											}
										>
											<Route path="/cadastro" element={<Cadastro />} />

											<Route
												exact
												path="/redefinirSenha"
												element={<SolicitarRedefinirSenha />}
											/>
											<Route
												exact
												path="/redefinirSenha/:token/:id"
												element={<RedefinirSenha />}
											/>
										</Route>
										<Route
											element={
												<Layout
													colorMode={colorMode}
													setColorMode={setColorMode}
													setContratoVencimento={setContratoVencimento}
													contratoVencimento={contratoVencimento}
												/>
											}
										>
											<Route path="/resumo" element={<></>} />
											<Route
												path="/home/perfil"
												element={
													<ErrorBoundary
														FallbackComponent={({
															error,
															resetErrorBoundary,
														}) => (
															<ErrorPageConnection
																error={error}
																resetErrorBoundary={resetErrorBoundary}
															/>
														)}
														resetKeys={["/home/perfil"]}
													>
														<Perfil />
													</ErrorBoundary>
												}
											>
												<Route
													path="/home/perfil/:id"
													element={<InternoPerfilCliente />}
												/>
												<Route path="/home/perfil/config/:id" element={<></>} />
												<Route
													path="/home/perfil/servicos/:id"
													element={<Acessos />}
												/>
												<Route
													path="/home/perfil/grupoEconomico/:id"
													element={<GrupoEconomicoPerfil />}
												/>
											</Route>
											<Route path="/templates" element={<Templates />} />

											<Route
												path="/versionamento"
												element={
													<ErrorBoundary
														FallbackComponent={({ error, resetErrorBoundary }) => (
															<ErrorPageConnection
																error={error}
																resetErrorBoundary={resetErrorBoundary}
															/>
														)}
														resetKeys={["/versionamento"]}
													>
														<Versionamento />
													</ErrorBoundary>
												}
											></Route>

											<Route path="/administracao" element={<ProtectedRoute />}>
												<Route
													path="/administracao/usuarios"
													element={
														<ErrorBoundary
															FallbackComponent={({
																error,
																resetErrorBoundary,
															}) => (
																<ErrorPageConnection
																	error={error}
																	resetErrorBoundary={resetErrorBoundary}
																/>
															)}
															resetKeys={["/administracao/usuarios"]}
														>
															<Usuarios />
														</ErrorBoundary>
													}
												/>

												<Route
													path="/administracao/auditoria"
													element={
														<ErrorBoundary
															FallbackComponent={({
																error,
																resetErrorBoundary,
															}) => (
																<ErrorPageConnection
																	error={error}
																	resetErrorBoundary={resetErrorBoundary}
																/>
															)}
															resetKeys={["/administracao/auditoria"]}
														>
															<PainelDeLogs />
														</ErrorBoundary>
													}
												></Route>
												<Route
													path="/administracao/integracaoErp"
													element={
														<ErrorBoundary
															FallbackComponent={({
																error,
																resetErrorBoundary,
															}) => (
																<ErrorPageConnection
																	error={error}
																	resetErrorBoundary={resetErrorBoundary}
																/>
															)}
															resetKeys={["/administracao/integracaoErp"]}
														>
															<IntegracaoErp />
														</ErrorBoundary>
													}
												/>
												<Route
													path="/administracao/licencas"
													element={
														<ErrorBoundary
															FallbackComponent={({
																error,
																resetErrorBoundary,
															}) => (
																<ErrorPageConnection
																	error={error}
																	resetErrorBoundary={resetErrorBoundary}
																/>
															)}
															resetKeys={["/administracao/licencas"]}
														>
															<Licencas />
														</ErrorBoundary>
													}
												/>
											</Route>

											<Route path="/home/perfil" element={<Perfil />} />
										</Route>

										{ClientRoute({
											pathName: "",
											colorMode: { colorMode },
											setColorMode,
										})}
										<Route path="/mirror">
											{ClientRoute({
												pathName: "/mirror",
												colorMode: { colorMode },
												setColorMode,
											})}
										</Route>
									</Routes>
								</ErrorBoundary>
							</RangeProvider>
						</Box>
					</ThemeProvider>
				}
			/>,
		),
	);

	return <RouterProvider router={router} />;
}
//
export default App;
